import jss from 'jss'
import preset from 'jss-preset-default'

export function generateVectorPosition(defaultObj, responsive, img, unit = "%") {
    let {top,left,right,bottom,width} = defaultObj
    jss.setup(preset())
    const styles = {
        img:{
            display: 'block !important',
            position: 'absolute',
        }
    }

    if(typeof top != 'undefined' && top !== '') {
      styles['img']['top'] = top + unit;
    }
    if(typeof left != 'undefined' && left !== '') {
        styles['img']['left'] = left + "%";
    }
    if(typeof bottom != 'undefined' && bottom !== '') {
      styles['img']['bottom'] = bottom + unit;
    }
    if(typeof right != 'undefined' && right !== '') {
        styles['img']['right'] = right + "%";
    }
    if(typeof width != 'undefined' && width !== '') {
        styles['img']['width'] = width + "px";
    }
    
    if(responsive) {
      responsive = JSON.parse(responsive);
      responsive.forEach(function(item) {
          let img_css = {};
          let {top,left,right,bottom,width,display} = item;

          if(typeof top != 'undefined' && top !== '') img_css['top'] = top;
          if(typeof left != 'undefined' && left !=='') img_css['left'] = left;
          if(typeof bottom != 'undefined' && bottom !== '') img_css['bottom'] = bottom;
          if(typeof right != 'undefined' && right !== '') img_css['right'] = right;
          if(typeof width != 'undefined') img_css['width'] = width + 'px';
          if(typeof display != 'undefined') img_css['display'] = display + " !important"; // Using with !important

          styles[`@media (max-width: ${item.breakpoint}px)`] = {
              img : img_css
          };
      })
    }

    const {classes} = jss.createStyleSheet(styles).attach()
    img.classList.add(classes.img)
}